import React, { useState, useRef, useEffect } from 'react';
import { Button, Card, Modal } from 'antd';
import { ShareAltOutlined, HeartOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import styles from './LiveVideo.module.scss';
import { useAppSelector } from '@/store/hooks';
import icon1 from '@/assets/images/组 3287@2x.png';
import icon2 from '@/assets/images/host-avatar.png';
import icon3 from '@/assets/images/生成美国风格直播封面 (4)@2x.png';
import icon4 from '@/assets/images/生成美国风格直播封面 (3)@2x.png';

import icon5 from '@/assets/images/路径 1918.png';
import icon6 from '@/assets/images/路径 1899.png';
import icon7 from '@/assets/images/路径 1919.png';
import icon8 from '@/assets/images/路径 1920.png';
import icon9 from '@/assets/images/路径 1902.png';

import { useNavigate, useSearchParams } from 'react-router-dom';
import DPlayer from 'dplayer';
import { useTranslation } from 'react-i18next';
// import 'dplayer/dist/DPlayer.min.css';

interface Product {
  id: string;
  name: string;
  price: number;
  image: string;
  featured?: boolean;
}

interface LiveVideoProps {
  className?: string;
  isStreamer?: boolean;//是否是主播
}

const LiveVideo: React.FC<LiveVideoProps> = ({ className, isStreamer = false }) => {
         const pc = useRef<RTCPeerConnection | null>(null);
         const mediaStream = useRef<MediaStream | null>(null);
         const playerContainerRef = useRef(null);
           //国际化
           const { t, i18n } = useTranslation();
         let dp:any ;
          // 获取查询参数
          const [searchParams] = useSearchParams();
          async function startPush() {
            console.log('startPush')
            // const liveid = searchParams.get('liveid');
            const liveid = 'jjf';
            
            try {
                const mediaInitialized = await initMediaSource();
                if (!mediaInitialized) {
                    return; // 如果媒体源初始化失败，则停止推流
                }
                
                const offerUrl = `http://${process.env.REACT_APP_API_URL}:1985/rtc/v1/publish/`;

                pc.current = new RTCPeerConnection({
                    iceServers: [{ urls: 'stun:stun.l.google.com:19302' }]
                });

                // 关键补丁 1：ICE 候选处理
                pc.current.onicecandidate = (e) => {
                    if (e.candidate) {
                        console.log('ICE Candidate:', e.candidate.candidate);
                    }
                };
                mediaStream?.current?.getTracks().forEach(track => {
                  if(mediaStream.current){
                    pc?.current?.addTrack(track, mediaStream?.current)
                  }
                });
                
                

                const offer = await pc.current.createOffer();
                await pc.current.setLocalDescription(offer);

                // 关键补丁 2：正确信令格式
                const resp = await fetch(`${offerUrl}?stream=${liveid}`, {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        sdp: pc?.current?.localDescription?.sdp ?? '',
                        streamurl: `webrtc://${process.env.REACT_APP_API_URL}/live/${liveid}`
                    })
                });

                const json = await resp.json();
                if (json.code !== 0) throw new Error("SRS error: " + json.code);

                await pc.current.setRemoteDescription(new RTCSessionDescription({
                    type: 'answer',
                    sdp: json.sdp
                }));

                // 持续推流监控
                pc.current.onconnectionstatechange = () => {
                    console.log('Connection state:', pc?.current?.connectionState);
                };

            } catch (e:any) {
                console.error("推流错误:", e);
                alert("推流错误: " + e.message);
            }
        }
        // 初始化摄像头或屏幕共享
        async function initMediaSource() {
            try {
                // 尝试获取摄像头访问权限，这是最可靠的摄像头检测方法
                let hasCamera = false;
                let cameraStream = null;
                
                try {
                    // 尝试访问摄像头，但立即停止，仅用于检测
                    cameraStream = await navigator.mediaDevices.getUserMedia({
                        video: { facingMode: 'user' },
                        audio: false
                    });
                    
                    // 如果成功获取到摄像头流，则说明摄像头可用
                    const videoTracks = cameraStream.getVideoTracks();
                    hasCamera = videoTracks.length > 0;
                    
                    // 立即停止测试用的摄像头流
                    videoTracks.forEach(track => track.stop());
                } catch (cameraError) {
                    // 如果获取摄像头失败，说明摄像头不可用或没有权限
                    console.log("摄像头不可用或无访问权限:", cameraError);
                    hasCamera = false;
                }
                
                // 根据摄像头检测结果显示不同的提示
                if (hasCamera) {
                    // 摄像头可用时询问用户选择
                    // const useCamera = confirm("是否开启摄像头进行直播？\n\n选择'确定'使用摄像头，选择'取消'使用屏幕共享。");
                    await showModal(1);
                    
                    // if (useCamera) {

                    // } else {

                    // }
                } else {
                    // 摄像头不可用时，直接询问是否使用屏幕共享
                    // const useScreenShare = confirm("未检测到可用的摄像头设备，是否使用屏幕共享进行直播？");
                    await showModal(2);
                    
                }
                const localVideo = document.getElementById('localVideo') as HTMLVideoElement | null;
                  if (localVideo) {
                    localVideo.srcObject = mediaStream.current;
                  }
                return true;
            } catch (e:any) {
                console.error("初始化媒体源失败:", e);
                // 根据不同的错误类型提供更具体的提示
                if (e.name === 'NotAllowedError' || e.name === 'PermissionDeniedError') {
                    alert("您拒绝了媒体设备访问权限。请在浏览器设置中允许访问摄像头或屏幕，然后重试。");
                } else if (e.name === 'NotFoundError' || e.name === 'DevicesNotFoundError') {
                    alert("未找到请求的媒体设备。请确保您的设备已连接摄像头或您的系统支持屏幕共享功能。");
                } else {
                    alert("无法获取媒体源，请确保您的浏览器有权限访问摄像头/屏幕，并且您的设备支持这些功能。\n错误详情: " + e.message);
                }
                return false;
            }
        }
                // 停止推流
        function stopPush() {
            if (pc.current) {
                pc.current.close();
                pc.current = null;
            }
            if (mediaStream.current) {
                mediaStream.current.getTracks().forEach(track => track.stop());
                mediaStream.current = null;
            }
            const localVideo = document.getElementById('localVideo') as HTMLVideoElement | null;
              if (localVideo) {
                localVideo.srcObject = null;
              }
            // document.getElementById('localVideo').srcObject = null;
        }
        
useEffect(()=>{
// startPush()

    if (playerContainerRef.current) {
      dp = new DPlayer({
        container: playerContainerRef.current,
        video: {
          url: 'http://192.168.1.116:8080/live/room_id.flv', // 替换为你的FLV视频URL
          type: 'auto',
        },
        autoplay: false,
        screenshot: true,
        hotkey: true,
        preload: 'metadata',
        volume: 0.7,
        mutex: true,
        lang: 'en',
        airplay: true,
        theme: '#FADFA3',
        loop: false,
        live: true,
        // danmaku: true,
        // apiBackend: {
        //   read: './dplayer.php',
        //   send: './dplayer.php',
        //   count: './dplayer.php',
        // },
        highlight: [
          {
            text: 'Highlight point',
            time: 120,
          },
        ],
      });
    }
    return () => {
      if (dp) {
        dp.destroy();
      }
    };
},[])

  const navigate = useNavigate();
  //是否是手机端
  const isMobile = useAppSelector((state) => state.searchBar.isMobile);
  // 模拟商品数据
  const products: Product[] = [
    {
      id: '1',
      name: 'wet n wild MegaGlo Highlighting Powder Warm Gold Golden',
      price: 5.99,
      image: icon3,
      featured: true
    },
    {
      id: '2',
      name: 'Makeup Brushes BS-MALL Premium Synthetic Foundation',
      price: 12.99,
      image: icon4,
    },
    {
      id: '3',
      name: 'wet n wild MegaGlo Highlighting Powder',
      price: 5.47,
      image: icon3,
    },
    {
      id: '4',
      name: 'BTFBM Long Sleeve Dress forWomen Fall 2025 High Waist',
      price: 45.22,
      image: icon4,
    },
    {
      id: '5',
      name: 'Home Goods Premium Bedding Set',
      price: 89.99,
      image: icon3,
    },
    {
      id: '6',
      name: 'Kitchen Appliance Set',
      price: 125.50,
      image: icon4,
    }
  ];

  const [currentProductIndex, setCurrentProductIndex] = useState(0);
  const scrollContainerRef = useRef<HTMLDivElement>(null);

  // 切换到下一个商品
  const handleNext = () => {
    if (currentProductIndex < products.length - 1) {
      const newIndex = currentProductIndex + 1;
      setCurrentProductIndex(newIndex);
      scrollToProduct(newIndex);
    }
  };

  // 切换到上一个商品  
  const handlePrev = () => {
    if (currentProductIndex > 0) {
      const newIndex = currentProductIndex - 1;
      setCurrentProductIndex(newIndex);
      scrollToProduct(newIndex);
    }
  };

  // 滚动到指定商品
  const scrollToProduct = (index: number) => {
    if (scrollContainerRef.current) {
      const container = scrollContainerRef.current;
      const productWidth = 280; // 商品卡片宽度 + gap
      const scrollLeft = index * productWidth;
      container.scrollTo({
        left: scrollLeft,
        behavior: 'smooth'
      });
    }
  };

  // 点击商品切换
  const handleProductClick = (index: number) => {
    setCurrentProductIndex(index);
    scrollToProduct(index);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);  //comfirm 状态 
  const [num, setNum] = useState(1);
  const showModal = (num: number) => {
    setIsModalOpen(true);
    setNum(num);
  };

  const handleOk = async() => {
    setIsModalOpen(false);
    if(num === 1){
        // 使用摄像头
      mediaStream.current = await navigator.mediaDevices.getUserMedia({
          video: true,
          audio: true
      });
    }else if(num === 2){ 
      mediaStream.current = await navigator.mediaDevices.getDisplayMedia({
          video: true,
          audio: {
              echoCancellation: true,
              noiseSuppression: true,
              autoGainControl: true
          }
      });
      
      // 屏幕共享结束时的处理
      if (mediaStream.current) {
        const videoTrack = mediaStream.current.getVideoTracks()[0];
        if (videoTrack) {
          videoTrack.onended = () => {
            console.log('屏幕共享已结束');
            stopPush();
          };
        }
      }
    }
  };

  const handleCancel = async() => {
    setIsModalOpen(false);
        if(num === 1){
          // 使用屏幕共享
          mediaStream.current = await navigator.mediaDevices.getDisplayMedia({
              video: true,
              audio: {
                  echoCancellation: true,
                  noiseSuppression: true,
                  autoGainControl: true
              }
          });
          
          // 屏幕共享结束时的处理
          mediaStream.current.getVideoTracks()[0].onended = () => {
              console.log('屏幕共享已结束');
              stopPush();
          };
    }else{
      return false;
    }
  };
  return (<>  
    <div className={`${styles.liveVideoContainer} ${className || ''}`}>
      {/* 视频播放区域 */}
      <div className={styles.videoSection}>
        <div className={styles.videoPlayer}>
          {/* LIVE 标志 */}
          {
            !isStreamer && (
              <div className={styles.liveIndicator}>
                <span className={styles.liveBadge}>{t('liveNow.liveLabel')}</span>
              </div>
            )
          }

          {
            isStreamer && (
              <div className='flex justify-between absolute top-0 left-0 bg-black/40 w-full h-[52px]
                px-[20px] py-[10px]
                z-10
                items-center
              '>
                <div className='flex items-center gap-[10px]'>
                  <img src={icon2} className='w-[31px] h-[31px] rounded-full' alt={t('liveNow.shopOwner')} />
                  <div>
                    <div className='text-[14px] font-bold text-[#fff] leading-[20px] mb-[5px]'>Basket Bonanza</div>
                    <div className='text-[12px] text-[#fff] leading-[17px] font-normal'>{t('liveNow.viewersCount', { count: 1000 })}</div>
                  </div>
                </div>
                <div className='text-right'>
                  <div className='text-[12px] text-[#fff] leading-[20px] mb-[5px]'>{t('liveNow.liveId', { id: '1234567890' })}</div>
                  <div className='text-[12px] font-normal text-[#fff] leading-[17px]'>{t('liveNow.orderQuantity', { count: 100 })}</div>
                </div>
              </div>
            )
          }
         

          {/* 视频占位图 */}
          <div className={styles.videoPlaceholder}>
            {/* <video id="localVideo" className='w-full h-full'></video> */}
            <div ref={playerContainerRef} style={{ width: '100%', margin: '0 auto', height: '100%' }}></div>
            {
              (isStreamer && !isMobile) && (
                <div className='absolute bottom-[8%] right-[200px]  h-[30px] z-10 flex items-center'>
                  <img src={icon5} className='w-[20px] h-[auto] mx-[6px] cursor-pointer' alt="Live Stream" 
                  onClick={() => navigate('/liveEnded')}/>
                  <img src={icon6} className='w-[20px] h-[auto] mx-[6px] cursor-pointer' alt="Live Stream" />
                  <img src={icon7} className='w-[20px] h-[auto] mx-[6px] cursor-pointer' alt="Live Stream" />
                  <img src={icon8} className='w-[20px] h-[auto] mx-[6px] cursor-pointer' alt="Live Stream" />
                  <img src={icon9} className='w-[20px] h-[auto] mx-[6px] cursor-pointer' alt="Live Stream" />
                </div>
              )
            }
          </div>

          {/* 右上角操作按钮 */}
          {
            !isStreamer && (
              <div className={styles.actionButtons}>
                <Button
                  type="text"
                  icon={<ShareAltOutlined />}
                  className={styles.actionBtn}
                />
                <Button
                  type="text"
                  icon={<HeartOutlined />}
                  className={styles.actionBtn}
                />
              </div>
            )
          }

        </div>

        {/* 主播信息 */}
        <div className='text-[16px] font-bold text-[#0D323E] mt-[10px]'>{t('liveNow.bohoVibesTitle')}</div>
        <div className={styles.hostInfo}>
          <div className={styles.hostProfile}>
            <div className={styles.hostAvatar}>
              <img src={icon2} alt="Sizzle Serve Yum" />
            </div>
            <div className={styles.hostDetails}>
              <h3 className={styles.hostName}>Sizzle Serve Yum</h3>
              <p className={styles.hostTag}>{t('liveNow.earnsCommissions')}</p>
            </div>
          </div>
          {
            !isStreamer && (
              <Button type="primary" className={styles.followBtn}>
                + {t('liveNow.Follow')}
              </Button>
            )
          }
          
        </div>
      </div>

      {/* 商品轮播区域 */}
      <div className={styles.productsSection}>
        <div className={styles.productsHeader}>
          <h3>{t('liveNow.productsFeatured')}</h3>
          <div className={styles.carouselControls}>
            <Button
              type="text"
              icon={<LeftOutlined />}
              onClick={handlePrev}
              disabled={currentProductIndex === 0}
              className={styles.carouselBtn}
            />
            <Button
              type="text"
              icon={<RightOutlined />}
              onClick={handleNext}
              disabled={currentProductIndex === products.length - 1}
              className={styles.carouselBtn}
            />
          </div>
        </div>

        <div className={styles.productsCarousel} ref={scrollContainerRef}>
          {products.map((product, index) => (
            <Card
              key={product.id}
              className={`${styles.productCard} ${index === currentProductIndex ? styles.active : ''}`}
              onClick={() => handleProductClick(index)}
              cover={
                <div className={styles.productImage}>
                  <img
                    src={product.image}
                    alt={product.name}
                    onError={(e) => {
                      // 图片加载失败时的处理
                      const target = e.target as HTMLImageElement;
                      target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjBmMGYwIi8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OTk5OSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZHk9Ii4zZW0iPk5vIEltYWdlPC90ZXh0Pjwvc3ZnPg==';
                    }}
                  />
                  {product.featured && (
                    <div className={styles.featuredBadge}>{t('liveNow.featuredNow')}</div>
                  )}
                </div>
              }
            >
              <div className={styles.productInfo}>
                <div className="text-[14px] font-bold text-[#0D323E]">{t('liveNow.amazonFinds')}</div>
                <h4 className={`${styles.productName} text-[#CFCFCF]`}>{product.name}</h4>
                <p className="text-[16px] font-bold text-[#0D323E]">${product.price}</p>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </div>
      <Modal
        title={t('liveNow.modalTitle')}
        closable={{ 'aria-label': 'Custom Close Button' }}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {num === 1 ? t('liveNow.useCameraDescription') : t('liveNow.noCamera')}
      </Modal>
    </>
  );
};

export default LiveVideo;
